export const FLYER_DATA_LOADING = 'FLYER_DATA_LOADING';
export const FLYER_DATA_PROGRESS = 'FLYER_DATA_PROGRESS';
export const FLYER_DATA_LOADED = 'FLYER_DATA_LOADED';
export const FLYER_DATA_SAVED = 'FLYER_DATA_SAVED';
export const FLYER_DATA_ERROR = 'FLYER_DATA_ERROR';
export const FLYER_DATA_FALLBACKURLS = 'FLYER_DATA_FALLBACKURLS';
